import React, { useContext } from "react";

// mui
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ArrowLeftRoundedIcon from "@mui/icons-material/ArrowLeftRounded";
import ArrowRightRoundedIcon from "@mui/icons-material/ArrowRightRounded";

// image
import { styled } from "@material-ui/styles";

// action
import { StoreContext } from "../../../../../../../../../store/StoreProvider";
import Act from "../../../../../../../../../store/actions";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  "&.MuiIconButton-root": {
    backgroundColor: "#3BBFF01A",
    color: "#3BBFF0",
    borderRadius: "6px",
    "&.Mui-disabled": {
      color: "#BDE7FA",
      backgroundColor: "#3BBFF01A",
    },
    "&:hover": {
      backgroundColor: "#E1F3FD",
      color: "#17A9E0",
    },
  },
}));

function CustomStepper() {
  const [state, dispatch] = useContext(StoreContext);
  const { digitalAI } = state;
  const { pagination } = digitalAI;
  const { activePage, totalPage } = pagination;

  const handleNext = () => {
    dispatch({
      type: Act.DIGITAL_AI_SET_ACTIVE_PAGE,
      payload: activePage + 1,
    });
  };

  const handleBack = () => {
    dispatch({
      type: Act.DIGITAL_AI_SET_ACTIVE_PAGE,
      payload: activePage - 1,
    });
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <StyledIconButton
        size="small"
        onClick={handleBack}
        disabled={activePage === 0}
      >
        <ArrowLeftRoundedIcon />
      </StyledIconButton>
      <Typography textAlign="left" variant="body2" sx={{ color: "#3BBFF0" }}>
        {`第${totalPage === 0 ? 0 : activePage + 1}/${totalPage}張`}
      </Typography>
      <StyledIconButton
        size="small"
        onClick={handleNext}
        disabled={totalPage === 0 || activePage === totalPage - 1}
      >
        <ArrowRightRoundedIcon />
      </StyledIconButton>
    </Box>
  );
}

export default CustomStepper;
